<template>
  <div>
    <div class="search fr-ac-jsb">
      <div class="fs-21 bold">{{ search.title }}</div>
      <div class="fr-ac-jsb">
        <el-input
          class="mr-10"
          style="width: 200px"
          v-model="searchItem"
          :placeholder="search.placeholder"
          suffix-icon="el-icon-search"
        />
        <div class="search-button" @click="toSearch">搜索</div>
      </div>
    </div>
    <div class="height">
      <div></div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.search {
  width: 100%;
  height: 75px;
  padding: 0 7%;
  background: #fff;
  .search-button {
    width: 65px;
    height: 40px;
    background: #1676ff;
    color: #fff;
    border-radius: 5px;
    line-height: 38px;
    text-align: center;
    cursor: pointer;
  }
}
.height {
  width: 100%;
  height: 10px;
  background: #fff;
  div {
    width: 90%;
    height: 1px;
    margin: 0 auto;
    background: #f2f2f2;
  }
}
</style>
<script>
export default {
  name: "SearchView",
  props: {
    search: Object,
  },
  data() {
    return {
      searchItem: "",
    };
  },
  methods: {
    toSearch() {
      this.$emit("search", this.searchItem.replace(/\s+/g, ""));
    },
  },
  mounted() {},
  created() {},
};
</script>
